import { Navigate } from "react-router-dom";
import DashboardOverview from "../pages/DashboardOverview";
import Layout from "../themes";
import Login from "../pages/Authentication/Login";
// import PasswordReset from "../pages/Authentication/PasswordReset";
import Queries from "../pages/Queries";
import AmadeusQueries from "../pages/Queries/Amadeus";
import AddUpdateQuery from "../pages/Queries/AddQuery";
import QueryDetail from "../pages/Queries/QueryDetail";
import Users from "../pages/UsersAndRoles/Users";
import Roles from "../pages/UsersAndRoles/Roles";
import Permissions from "src/pages/UsersAndRoles/Permissions";
import EmailTemplates from "src/pages/EmailTemplates";
import { authUserProps } from "src/interfaces";
import { selectAuthUser } from "src/stores/auth";
import { useAppSelector } from "src/stores";
import Actionable from "src/pages/Queries/Actionable";
import Customers from "src/pages/Customers";
import CustomerDetail from "src/pages/Customers/detail";
import ColdFollowUp from "src/pages/Queries/ColdFollowUp";
import Locations from "src/pages/UsersAndRoles/Locations";
import MillwoodsDocs from "src/pages/MillwoodsDocs";
import PasswordReset from "src/pages/Authentication/PasswordReset";
import Reminders from "src/pages/Reminders";
import CallLogs from "src/pages/CallLogs";
import CallDetailsPage from "src/pages/CallLogs/CallDetails";
import ReminderDetail from "src/pages/Reminders/ReminderDetail";
import ClearCache from "src/pages/ClearCache";
import MillwoodsCallLogDocs from "src/pages/MillwoodsCallLogDocs";
import MillwoodsAdminCallLogDocs from "src/pages/MillwoodsAdminCallLogDocs";
import CallLogsAnalytics from "src/pages/CallLogsAnalytics";
// import NotificationSample from "src/pages/NotificationSample";
export const useAppRoutes = (): {
  path?: string;
  element?: any;
  title?: string | React.ReactNode;
  children?: { path?: string; element?: any; title?: string }[];
}[] => {
  let authUser: authUserProps = useAppSelector(selectAuthUser) || ({} as any);
  const isLoggedIn = !!authUser?.token;
  const userType = authUser?.user_type;
  const permissions = authUser?.role?.permissions;
  const allRoutes = !isLoggedIn
    ? []
    : [
        {
          path: "",
          title: "Home",
          element: <Layout />,
          children: [
            {
              path: "*",
              element: <Navigate to={"/"} />,
            },
            {
              title: "Analytics",
              path: "/",
              element: <DashboardOverview />,
            },
            {
              title: "Queries",
              path: "create-query",
              element: <AddUpdateQuery />,
            },
            {
              title: "Users",
              path: "users",
              element: <Users />,
            },
            {
              title: "Query",
              path: "query-detail/:id/:no?",
              element: <QueryDetail />,
            },
            {
              title: "Query",
              path: "amadeus-query-detail/:id/:no?",
              element: <QueryDetail />,
            },
            {
              title: "Queries",
              path: "queries",
              element: <Queries />,
            },
            {
              title: "Amadeus Queries",
              path: "amadeus-queries",
              element: <AmadeusQueries />,
            },
            {
              title: "Queries",
              path: "search-queries",
              element: <Queries />,
            },
            {
              title: "Queries",
              path: "all",
              element: <Queries />,
            },
            {
              title: "My Actionable",
              path: "actionable",
              element: <Actionable />,
            },
            {
              title: "Reminders",
              path: "reminders",
              element: <Reminders />,
            },
            {
              title: "Reminder Detail",
              path: "reminders-details/:id",
              element: <ReminderDetail />,
            },
            {
              title: "Email Templates",
              path: "email-templates",
              element: <EmailTemplates />,
            },
            {
              title: "Customers",
              path: "customers",
              element: <Customers />,
            },
            {
              title: "Call Logs",
              path: "call-logs",
              element: <CallLogs />,
            },

            {
              title: "Call Logs",
              path: "call-logs-analytics",
              element: <CallLogsAnalytics />,
            },
            // {
            //   title: "Notification Sample",
            //   path: "notification-sample",
            //   element: <NotificationSample />,
            // },
            {
              title: "Call Details",
              path: "call-logs/:id",
              element: <CallDetailsPage />,
            },
            {
              title: "Customer Detail",
              path: "customer-detail/:id",
              element: <CustomerDetail />,
            },
          ],
        },
      ];

  let permittedRoutes: any[] = [
    {
      path: "*",
      element: <Navigate to={isLoggedIn ? "/" : "/login"} />,
    },
    {
      path: "/call-log-user-guide",
      element: <MillwoodsCallLogDocs />,
    },
    {
      path: "/call-log-admin-guide",
      element: <MillwoodsAdminCallLogDocs />,
    },
    {
      path: "/user-guide",
      element: <MillwoodsDocs />,
    },
    // Support / debugging route to clear client cache
    {
      path: "/clear-cache",
      element: <ClearCache />,
    },
  ];
  if (!isLoggedIn) {
    permittedRoutes.push(
      ...[
        {
          path: "*",
          element: <Navigate to={"login"} />,
        },
        {
          title: "Login",
          path: "/login",
          element: <Login />,
          children: undefined,
        },
        {
          title: "Password Reset",
          path: "/password-reset",
          element: <PasswordReset />,
          children: undefined,
        },
      ],
    );
  }

  if (isLoggedIn && userType == "Superadmin") {
    permittedRoutes.push(
      ...[
        {
          path: "",
          title: "Permissions",
          element: <Layout />,
          children: [
            {
              title: "Permissions",
              path: "/",
              element: <Permissions />,
            },
            {
              title: "Roles",
              path: "roles",
              element: <Roles />,
            },
            {
              title: "Users",
              path: "users",
              element: <Users />,
            },
            {
              title: "Locations",
              path: "locations",
              element: <Locations />,
            },
          ],
        },
      ],
    );
  } else if (isLoggedIn && userType == "Admin") {
    permittedRoutes.push(
      ...[
        {
          path: "",
          title: "Home",
          element: <Layout />,
          children: [
            {
              path: "*",
              element: <Navigate to={isLoggedIn ? "/" : "login"} />,
            },
            {
              title: "Analytics",
              path: "/",
              element: <DashboardOverview />,
            },
            {
              title: "Reminders",
              path: "reminders",
              element: <Reminders />,
            },
            {
              title: "Call Logs",
              path: "call-logs",
              element: <CallLogs />,
            },

            {
              title: "Cold Follow-up's",
              path: "cold-follow-up",
              element: <ColdFollowUp />,
            },
            // {
            //   title: "Notification Sample",
            //   path: "notification-sample",
            //   element: <NotificationSample />,
            // },
          ],
        },
        ...allRoutes,
      ],
    );
  } else if (isLoggedIn) {
    permittedRoutes.push(
      ...[
        {
          path: "",
          title: "Home",
          element: <Layout />,
          children: [
            {
              path: "*",
              element: <Navigate to={isLoggedIn ? "/" : "login"} />,
            },
            {
              title: "Analytics",
              path: "/",
              element: <DashboardOverview />,
            },
            {
              title: "Cold Follow-up's",
              path: "cold-follow-up",
              element: <ColdFollowUp />,
            },
          ],
        },
        ...allRoutes?.filter((ele) =>
          permissions?.some(
            (p) =>
              p.frontend_route?.replace("/", "") == ele?.path ||
              ele?.children?.some(
                (ce) => ce.path == p.frontend_route?.replace("/", ""),
              ),
          ),
        ),
      ],
    );
  }
  return permittedRoutes;
};
